<template>
	<div class="login-overlay">
		<div class="login-overlay__wrapper">
			<div class="login-overlay__container">
				<div class="login-overlay__info">
					<h2 v-html="$t('login.brandsTitle')"/>
					<div class="migration__text" v-html="$t('login.brandsText')" />
					<h3
						v-if="brands.length"
						v-html="$t('login.brandsSubtitle')"
					/>
					<ul
						v-if="brands.length"
						class="migration__brands migration__brands--all"
					>
						<li
							v-for="brand in brands"
							:key="brand.code"
							class="migration__brand migration__brand--all"
						>
							<component
								:is="iconComponent(`logo-simple-${brand.code}`)"
								class="migration__brand-logo"
							/>
						</li>
					</ul>
				</div>
				<div class="login-overlay__options">
					<div class="login-overlay__tabs">
						<button
							class="login-overlay__tab"
							:class="{
								'login-overlay__tab--active': activeTab == 'login'
							}"
							v-html="$t('login.loginTab')"
							type="button"
							@click.prevent="setActiveTab('login')"
						/>
						<button
							class="login-overlay__tab"
							:class="{
								'login-overlay__tab--active': activeTab == 'register'
							}"
							v-html="$t('login.registerTab')"
							type="button"
							@click.prevent="setActiveTab('register')"
						/>
					</div>
					<div
						class="login-overlay__tab-content"
						v-show="activeTab == 'login'"
					>
						<FormLogin
							hide-title
							ref="loginForm"
							@loggedIn="onLoggedIn"
						/>
						<!-- <h3 v-html="$t('login.loginRegisterTitle')"/>
						<Button
							@click.prevent="setActiveTab('register')"
							type="button"
							level="tertiary"
							:text="$t('login.loginRegisterButton')"
							arrow
						/> -->
					</div>
					<div
						class="login-overlay__tab-content"
						v-show="activeTab == 'register'"
					>
						<FormRegister
							hide-title
							ref="registerForm"
						/>
						<!-- <h3 v-html="$t('login.registerLoginTitle')"/>
						<Button
							@click.prevent="setActiveTab('login')"
							type="button"
							level="tertiary"
							:text="$t('login.registerLoginButton')"
							arrow
						/> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue"
import {mapGetters} from 'vuex'
import GenericMixin from '@/mixins/GenericVueMixin';
import OverlayMixin from '@/mixins/OverlayVueMixin';
import FormLogin from '@/components/FormLogin';
import FormRegister from '@/components/FormRegister';
import Button from '@/components/Button';
import htmlComponent from 'htmlcomponent'
import sleep from '@/utils/sleep';

export default {
	mixins: [
		GenericMixin,
		OverlayMixin,
	],
	components: {
		FormLogin,
		FormRegister,
		Button,
	},
	props: {
		overlayType: {
			type: String,
			default() {
				return 'login';
			},
		},
	},
	data() {
		return {
			activeTab: 'login',
		}
	},
	computed: {
		...mapGetters([
			'brands'
		]),
	},
	methods: {
		resetForm() {
			this.$refs.loginForm.resetForm();
			this.$refs.registerForm.resetForm();
		},
		setActiveTab(tab = 'login') {
			this.activeTab = tab;
		},
		async onLoggedIn() {
			await sleep(2000);
			this.closeOverlay();
		},
		async beforeOverlayOpen(data) {
			this.$store.dispatch('loader/setLoading', true);
			this.setActiveTab(data.tab);
		},
		async afterOverlayOpen() {
			await this.$store.dispatch('getBrands');
			this.$store.dispatch('loader/setLoading', false);
		},
		afterOverlayClose() {
			this.resetForm();
		},
	},
}
</script>

<style>

</style>
